import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";

export default async function confirmParcisionCloseOutRequest(cid: number) {
  try {
    const variables = { cid };

    const query = gql`
      query MyQuery($cid: Float!) {
        closeOutParcisionWalletV2(cid: $cid) {
          stats {
            snap
            goptin
            gprize
          }
          local {
            snap
            stage
            estimate1
            estimate2
            estimate3
            wager
            description
            research
            tid
          }
          participants {
            addr
            snap
            estimate1
            estimate2
            estimate3
            wager
            return
            description
            research
          }
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.closeOutParcisionWalletV2;
  } catch (error) {
    toast.error("Failed to close out contract");
    sentryWrappedException(error);
    throw error;
  }
}
